import { createStore } from 'vuex'
import createVuexAlong from 'vuex-along'

export default createStore({
    state: {
        // token: 'egsp:token:eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIxOSJ9.hYKvvwa47uGP37qjyDdJtXmuul22UnMi7Mrj3yttuL4',
        token: '',
        tenantId: 1,
        userInfo: {}
    },
    getters: {},
    mutations: {
        changeToken(state, params) {
            state.token = params
        },
        changeUserInfo(state, params) {
            state.userInfo = params
        },
    },
    actions: {},
    modules: {},
    plugins: [createVuexAlong({
        name: 'emergency',
        session: {
            list: ['userInfo', 'token']
        },
        justSession: true

    })]
})